<div (clickOutside)="closeSearchResults()">
    <div class="me-3">
        <div class="row justify-content-end position-relative">
            @if (searchControl) {
                <div
                    class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-3 search-field-col"
                    [class.search-field-native]="isNative"
                >
                    <form (ngSubmit)="search()">
                        <input
                            #searchEl
                            data-cy="SEARCH"
                            type="search"
                            enterkeyhint="search"
                            autocomplete="off"
                            [formControl]="searchControl"
                            id="search-field"
                            [placeholder]="'Suchen' | translate"
                            [attr.role]="searchFieldStore.recentSearchesEnabled() ? 'combobox' : null"
                            [attr.aria-autocomplete]="searchFieldStore.recentSearchesEnabled() ? 'list' : null"
                            [attr.aria-controls]="
                                searchFieldStore.recentSearchesEnabled() ? 'search-recent-queries' : null
                            "
                            [attr.aria-expanded]="
                                searchFieldStore.recentSearchesEnabled() ? searchFieldStore.recentListVisible() : null
                            "
                            [attr.aria-activedescendant]="searchFieldStore.activeOptionId()"
                            (focusin)="searchOpen = true; searchFieldStore.openList()"
                            (click)="searchFieldStore.openList()"
                            (input)="searchFieldStore.openList()"
                            (keydown)="onSearchKeydown($event)"
                            class="form-control full-width"
                            tabindex="1"
                        />
                        <button
                            mat-icon-button
                            color="accent"
                            type="submit"
                            id="searchsubmit"
                            data-cy="SEARCH_SUBMIT"
                            [disabled]="!searchFieldStore.hasQuery()"
                            [attr.aria-label]="'Suchen' | translate"
                        >
                            <em class="fas fa-search"></em>
                        </button>
                    </form>
                    @if (searchControl?.value) {
                        <button mat-icon-button color="accent" id="searchclear" (click)="reset()">
                            <em class="fas fa-times"></em>
                        </button>
                    }
                    <button mat-icon-button color="accent" id="barcodeBtn" (click)="barcodeScan()" *showIfApp>
                        <em class="fas fa-barcode"></em>
                    </button>
                    @if (searchFieldStore.recentListVisible()) {
                        <div class="dropdown-menu show search-recent-list" (mousedown)="$event.preventDefault()">
                            <h6 class="dropdown-header" id="search-recent-queries-label">
                                {{ 'Letzte Suchen' | translate }}
                            </h6>
                            <ul
                                id="search-recent-queries"
                                role="listbox"
                                class="list-unstyled mb-0"
                                aria-labelledby="search-recent-queries-label"
                            >
                                @for (option of searchFieldStore.recentOptions(); track option.query) {
                                    <li
                                        [id]="option.optionId"
                                        role="option"
                                        class="dropdown-item d-flex align-items-center search-recent-option"
                                        data-cy="SEARCH_RECENT_QUERY"
                                        [class.active]="option.active"
                                        [attr.aria-selected]="option.active"
                                        (click)="selectRecentQuery(option.query)"
                                    >
                                        <em class="fas fa-history me-2" aria-hidden="true"></em>
                                        <span class="flex-grow-1 text-truncate">{{ option.query }}</span>
                                        <button
                                            type="button"
                                            class="btn btn-link btn-sm p-0 ms-2 search-recent-remove"
                                            tabindex="-1"
                                            aria-hidden="true"
                                            data-cy="SEARCH_RECENT_QUERY_REMOVE"
                                            [title]="'Eintrag entfernen' | translate"
                                            (click)="removeRecentQuery($event, option.query)"
                                        >
                                            <em class="fas fa-times" aria-hidden="true"></em>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
